



































import DictMixin from '@/mixins/dict-mixin';
import { IndicatorDto } from '@/services/indicator';
import { mixins } from 'vue-class-component';
import { Component, PropSync, Watch } from 'vue-property-decorator';
@Component
export default class IndF3 extends mixins(DictMixin) {
  @PropSync('formData') syncFormData!: IndicatorDto;

  userInfo: string = '';

  selectUser(user: { userId: string; userName: string }) {
    this.syncFormData.indOwnerUid = user.userId;
    this.syncFormData.indOwnerName = user.userName;
  }

  @Watch('syncFormData', { deep: true })
  onBaseChange() {
    this.indOwnerPlate = this.syncFormData.indOwnerPlate || '';
    this.indOwnerDept = this.syncFormData.indOwnerDept || '';
    if (this.syncFormData.indOwnerUid) {
      this.userInfo = `${this.syncFormData.indOwnerUid}/${this.syncFormData.indOwnerName}`;
    } else {
      this.userInfo = '';
    }
  }

  indOwnerPlate: string = '';
  indOwnerDept: string = '';
  DEPT_LIST: any[] = [];
  @Watch('indOwnerPlate')
  changePlate(e: string) {
    if (!this.DICT_BUSINESS_UNIT) {
      setTimeout(() => {
        this.changePlate(e);
      }, 100);
      return false;
    }
    this.DEPT_LIST = [];
    if (e) {
      let item = this.DICT_BUSINESS_UNIT.find((v: any) => v.value === e);
      this.DEPT_LIST = this.DICT_BUSINESS_DEPT.filter((v: any) => v.parentItemCode === item.dictItemCode);
    }
    this.syncFormData.indOwnerPlate = e;

    // 当前部门信息不在部门列表中时置空部门信息
    if (this.indOwnerDept && this.DEPT_LIST.filter(v => v.value == this.indOwnerDept).length === 0) {
      this.indOwnerDept = '';
      this.changeDept(this.indOwnerDept);
    }
  }

  @Watch('indOwnerDept')
  changeDept(e: string) {
    this.syncFormData.indOwnerDept = e;
  }
}
